<template>
    <div class="login-box">
        <div class="center">
            <div><img src="../assets/login_page_logo.svg" class="logo" alt="LOGO"></div>
            <h1 class="title">Welcome to DocAnalyzer</h1>
            <form @submit.prevent="submit" ref="form">
                <div class="input-fields">
                    <template v-if="fixedUserName">
                        <input name="username" :value="fixedUserName" autocomplete="username" readonly
                               style="display: none">
                        <div class="form-control">
                            <div><input type="password" placeholder="Password" required name="password"
                                        autocomplete="current-password" autofocus></div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="form-control">
                            <div>
                                <input spellcheck="false" autofocus placeholder="Username" required name="username"
                                       autocomplete="username">
                            </div>
                        </div>
                        <div class="form-control">
                            <div><input type="password" placeholder="Password" required name="password"
                                        autocomplete="current-password"></div>
                        </div>
                    </template>
                </div>
                <div>
                    <button class="button-primary" type="submit" v-if="fixedUserName">Log In As "{{fixedUserName}}"</button>
                    <button class="button-primary" type="submit" v-else>Log In</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

    import {doUserLogin} from "@/apis";
    import {authHelper} from "@/utils";

    export default {
        name: "Login",
        methods: {
            submit(event) {
                const elements = event.currentTarget.elements;
                let username = elements.username.value.trim();
                let password = elements.password.value.trim();
                if (username && password) {
                    doUserLogin(username, password).then(r => {
                        if (r['authenticated']) {
                            authHelper.setUserInfo(r['user_info'])
                            authHelper.setUserAuthenticated(true)

                            let redirectTo = this.$route.query.redirectTo;
                            if (redirectTo) {
                                this.$router.replace(redirectTo);
                            } else {
                                this.$router.replace({name: 'home'});
                            }

                        } else {
                            alert('Invalid username or password. Please try again!')
                        }
                    }).catch(() => {
                        alert('There was something not right while logging you in.')
                    })
                }
            }
        },
        created() {
            if (this.$route.query.r === 'renew' && authHelper.getUserInfo()) {
                this.fixedUserName = authHelper.getUserInfo().username;
            }
        },
        mounted() {
            this.$refs.form.querySelector('[autofocus]').focus();
        },
        data() {
            return {
                fixedUserName: null
            }
        }
    }
</script>

<style scoped lang="scss">
    .center {
      text-align: center;
      margin-top: -100px;
      border-radius: 8px;
      padding: 2rem 3.5rem 2rem;
      box-shadow: 0 12px 18px 2px rgba(34, 0, 51, .04), 0 6px 22px 4px rgba(7, 48, 114, .12), 0 6px 10px -4px rgba(14, 13, 26, .12);
      background: white;
    }

    .title {
        margin: 1.5rem 0 1.5rem;
        font-size: 1.32rem;
        font-weight: 500;
    }

    form {
        text-align: center;
        width: 200px;
        margin: 0 auto;

        .input-fields {
            margin: 1.5rem 0 1.5rem;
        }

        input {
            margin: 0.2rem 0;
            width: 100%;
        }

        .form-control {
            margin-bottom: 0.6rem;
        }

        button {
            width: 100%;
        }
    }

    .login-box {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #4158D0;
      background-image: linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);
    }
</style>
